module.exports = __webpack_public_path__ + "img/流体力学2_4_1.634ad621.jpg";